export const updateUserMessage = (payload)=>{
    return {
        type: 'SET_USER_MESSAGE',
        payload
    }
}